import React from "react";

const BTN =
  "rounded border border-slate-600 bg-slate-800 px-2 py-1 text-xs font-semibold text-slate-100 hover:bg-slate-700 active:bg-slate-600 disabled:opacity-40";

export default function CctvPtzPad({ disabled, onAction }) {
  const go = (action) => {
    if (disabled) return;
    onAction?.(action);
  };

  return (
    <div className="grid grid-cols-3 gap-1 w-[132px]">
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("up_left")}>
        ↖
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("up")}>
        ↑
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("up_right")}>
        ↗
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("left")}>
        ←
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("stop")}>
        ■
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("right")}>
        →
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("down_left")}>
        ↙
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("down")}>
        ↓
      </button>
      <button type="button" className={BTN} disabled={disabled} onClick={() => go("down_right")}>
        ↘
      </button>
      <button type="button" className={`${BTN} col-span-3`} disabled={disabled} onClick={() => go("zoom_in")}>
        Zoom +
      </button>
      <button type="button" className={`${BTN} col-span-3`} disabled={disabled} onClick={() => go("zoom_out")}>
        Zoom −
      </button>
    </div>
  );
}
